import { format } from 'date-fns';

export const formatNumber = (num) => {
  return new Intl.NumberFormat('ko-KR').format(num);
};

export const formatCurrency = (num) => {
  return `${formatNumber(num)}원`;
};

export const formatPercent = (num, decimals = 2) => {
  return `${num >= 0 ? '+' : ''}${num.toFixed(decimals)}%`;
};

export const formatDate = (dateString) => {
  return format(new Date(dateString), 'yyyy-MM-dd');
};

export const formatDateTime = (dateString) => {
  return format(new Date(dateString), 'yyyy-MM-dd HH:mm:ss');
};

export const formatTime = (dateString) => {
  return format(new Date(dateString), 'HH:mm:ss');
};
